import React, { useEffect, useState } from 'react';
import { eanValido } from '../../lib/services/gruService';
import { generaSvgEan13 } from '../../lib/gruBarcode';

// Codice a barre EAN-13 in SVG (vettoriale: nitido a qualsiasi risoluzione e in stampa).
// La generazione dell'SVG (con JsBarcode, caricato solo quando serve) è in lib/gruBarcode.js.

export { generaSvgEan13 };

/** Stato di generazione del codice a barre: { svg, errore, caricamento } */
export const useBarcodeEan13 = (ean) => {
  const [stato, setStato] = useState({ svg: null, errore: null, caricamento: true });

  useEffect(() => {
    let annullato = false;
    const valore = String(ean ?? '').trim();

    if (!valore) {
      setStato({ svg: null, errore: 'EAN mancante: impossibile generare il codice a barre.', caricamento: false });
      return undefined;
    }
    if (!eanValido(valore)) {
      setStato({ svg: null, errore: 'EAN non valido (servono 13 cifre con cifra di controllo corretta).', caricamento: false });
      return undefined;
    }

    setStato((precedente) => ({ ...precedente, caricamento: true, errore: null }));
    generaSvgEan13(valore)
      .then((svg) => {
        if (!annullato) setStato({ svg, errore: null, caricamento: false });
      })
      .catch(() => {
        if (!annullato) setStato({ svg: null, errore: 'Impossibile generare il codice a barre.', caricamento: false });
      });
    return () => { annullato = true; };
  }, [ean]);

  return stato;
};

/**
 * Codice a barre EAN-13 (solo visualizzazione) su fondo bianco con il numero leggibile sotto.
 * La larghezza si imposta con className (es. "w-[130px]"); l'altezza segue le proporzioni.
 */
const BarcodeEan13 = ({ valore, className = 'w-[130px]' }) => {
  const { svg, errore, caricamento } = useBarcodeEan13(valore);

  if (errore) {
    return (
      <div className={`${className} rounded-lg border border-red-500/30 bg-red-500/5 px-2 py-1.5`}>
        <p className="text-[8px] font-black uppercase tracking-wider text-red-500 leading-tight">
          {valore ? 'EAN non valido' : 'EAN mancante'}
        </p>
      </div>
    );
  }

  return (
    <div
      className={`${className} bg-white rounded-lg p-1 border border-border/40 shadow-sm`}
      aria-label={`Codice a barre EAN-13 ${valore}`}
      role="img"
    >
      {caricamento || !svg ? (
        <div className="aspect-[2.3/1] w-full rounded bg-muted/20 animate-pulse" />
      ) : (
        <div className="[&>svg]:block [&>svg]:w-full [&>svg]:h-auto" dangerouslySetInnerHTML={{ __html: svg }} />
      )}
    </div>
  );
};

export default BarcodeEan13;
